import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Setting from '@/components/Setting'

Vue.use(Router)

export default new Router({
	history: true,
	hashbang: false,
	mode: "history",
  routes: [
    {
      path: '/',
      name: 'LOGIN',
      component: Login
    },
	{
      path: '/HOME',
      name: 'HOME',
      component: Home
    },
	{
      path: '/SETTING',
      name: 'SETTING',
      component: Setting
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js